<template>
  <div class="container">
    <div class="searchBox">
      <el-form size="mini" :model="searchInfo" ref="form">
        <el-row>
          <el-col :span="8">
            <el-form-item label="学员搜素: " prop="student_id">
              <el-input
                v-model="searchInfo.student_key_word"
                placeholder="学员姓名/手机号"
                @change="handleSearch"
                clearable
                @clear="handleSearch"
                prefix-icon="el-icon-search"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程顾问: " prop="course_adviser">
              <common-staff-pull-down
                :originId.sync="searchInfo.course_adviser"
                :defaultSelected.sync="searchInfo.course_adviser_list"
                :jobIds="[3]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="教务老师: " prop="staff_teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.staff_teacher_id"
                :defaultSelected.sync="searchInfo.staff_teacher_list"
                :jobIds="[2]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="课程老师: " prop="teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :jobIds="[1]"
                :defaultSelected.sync="searchInfo.teacher_list"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="科目: " prop="subject_id">
              <el-select
                v-model="searchInfo.subject_id"
                placeholder="请选择"
                clearable
                filterable
                :filter-method="handleSearchSubjectList"
                @focus="handleSearchSubjectList('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in subjectList"
                  :key="item.subject_id"
                  :label="item.subject_title"
                  :value="item.subject_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课程名称: " prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                placeholder="请选择"
                clearable
                filterable
                :filter-method="handleSearchCourseList"
                @focus="handleSearchCourseList('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div :style="showFormSearch ? 'display: block;' : 'display: none;'">
          <el-row>
            <el-col :span="8">
              <el-form-item label="课程类型: " prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">1vN</el-radio-button>
                  <el-radio-button :label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结课时间: ">
                <common-date-range-selector
                  v-model="searchInfo.class_time"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  format="yyyy-MM-dd"
                  clearable
                  @change="handleSearch"
                  :picker-options="effectiveDate"
                >
                </common-date-range-selector>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="结课状态: " prop="status">
                <el-radio-group
                  v-model="searchInfo.status"
                  @change="handleSearch"
                  size="mini"
                >
                  <el-radio-button :label="-1">全部</el-radio-button>
                  <el-radio-button :label="1">正常</el-radio-button>
                  <el-radio-button :label="2">已撤销</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="time-line-switch">
        <div class="btn" @click="showFormSearch = !showFormSearch">
          {{ showFormSearch ? "收起" : "展开" }}
          <span
            :class="showFormSearch ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          ></span>
        </div>
        <div class="btn" @click="handleSearchRefresh">
          重置<span class="el-icon-refresh-right"></span>
        </div>
      </div>
    </div>
    <el-table
      :data="tableData"
      v-horizontal-scroll
      stripe
      style="width: 100%"
      :default-sort="{ prop: 'completion_time', order: 'descending' }"
      @sort-change="clickSort"
    >
      <el-table-column prop="student.name" label="学员姓名">
        <template slot-scope="scope">
          <div class="mwow-green cu-po" @click="goStudentDetail(scope.row)">
            {{ scope.row.student.name || "-" }}
            <span
              class="mwow-tag success-filled"
              v-if="scope.row.student.status === 1"
              >意向</span
            >
            <span
              class="mwow-tag success-filled"
              v-if="scope.row.student.status === 2"
              >在读</span
            >
            <span
              class="mwow-tag danger-filled"
              v-if="scope.row.student.status === 3"
              >历史</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="follow_staff.name" label="课程顾问">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.follow_staff === null
                ? "-"
                : scope.row.follow_staff.name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="edu_teacher.name" label="教务老师">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.edu_teacher === null ? "-" : scope.row.edu_teacher.name
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="课程老师">
        <template slot-scope="scope">
          <div>
            {{
              scope.row.teacher_list
                .map((it) => {
                  return it.name;
                })
                .join("、") || "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="subject.subject_title"
        label="科目"
      ></el-table-column>
      <el-table-column prop="course.title" label="课程名称"></el-table-column>
      <el-table-column prop="course.course_type" label="课程类型">
        <template slot-scope="scope">
          <div>
            {{ scope.row.course.course_type === 1 ? "1vN" : "1v1" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="completion_time"
        label="结课时间"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
        width="132px"
      ></el-table-column>
      <el-table-column prop="status" label="结课状态">
        <template slot-scope="scope">{{
          scope.row.completion_status === 1 ? "正常" : "已撤销"
        }}</template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot="header">
          <div>
            <span>操作</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="200"
            >
              <p>学员同一个课程有多次结课记录时，只能撤销最后一次结课</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin-left: 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </div>
        </template>
        <template slot-scope="scope">
          <div
            v-if="
              scope.row.completion_status === 1 &&
              scope.row.student.status !== 3
            "
            class="mwow-button"
            @click="handleCompletionCancel(scope.row)"
          >
            撤销
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import { getSeleSubjectsList, getSelectCourseList } from "@/api/globalSearch";
import { completionListApi } from "@/api/studentManage";
import { cancelCourseFinishApi } from "@/api/studyDetails";
import { dateFormat } from "@/utils/timeFormat";
import { mixin } from "@/mixin/tabPageInfoMixin";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";

export default {
  components: {
    commonStaffPullDown,
    commonDateRangeSelector,
  },
  mixins: [mixin],
  props: ["visible"],
  data() {
    return {
      searchInfo: {
        student_key_word: "",
        course_type: -1,
        class_time: [],
        sort_type: "desc",
        sort_field: "",
        course_adviser: "",
        course_adviser_list: [],
        staff_teacher_id: "",
        staff_teacher_list: [],
        teacher_id: "",
        teacher_list: [],
      },
      adviserList: [],
      staffTeacherList: [],
      teacherList: [],
      subjectList: [],
      courseList: [],
      tableData: [],
      page: 1,
      pageSize: 10,
      showFormSearch: false,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      // 未来时间应不可选
      effectiveDate: {
        disabledDate(date) {
          return date.getTime() > Date.now();
        },
      },
    };
  },

  created() {
    // 来自续费数据页面
    if (
      this.$route.query.from === "renewal" &&
      this.$route.query.val === "course_completion"
    ) {
      this.searchInfo.class_time[0] = this.$route.query.s_time;
      this.searchInfo.class_time[1] = this.$route.query.e_time;
      if (this.$route.query.key === "staff") {
        this.searchInfo.course_adviser = Number(this.$route.query.id);
        this.searchInfo.course_adviser_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "edu_teacher") {
        this.searchInfo.staff_teacher_id = Number(this.$route.query.id);
        this.searchInfo.staff_teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "teacher") {
        this.searchInfo.teacher_id = Number(this.$route.query.id);
        this.searchInfo.teacher_list = [
          {
            staff_id: Number(this.$route.query.id),
            name: this.$route.query.label,
          },
        ];
      }
      if (this.$route.query.key === "course") {
        this.searchInfo.course_id = Number(this.$route.query.id);
        this.searchInfo.courseList = [
          {
            course_id: Number(this.$route.query.id),
            title: this.$route.query.label,
          },
        ];
      }
    }
    this.mixinGetPageInfo("closingRecordSearch");
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.getList({
          page: this.page,
          page_size: this.pageSize,
        });
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    }
  },
  methods: {
    handleSearchSubjectList(v) {
      getSeleSubjectsList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.subjectList = res.data.list;
        }
      });
    },
    handleSearchCourseList(v) {
      getSelectCourseList({
        page: 1,
        page_size: 1000,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
    },
    handleSearchRefresh() {
      this.searchInfo = {
        student_key_word: "",
        course_adviser: "",
        staff_teacher_id: "",
        teacher_id: "",
        subject_id: "",
        course_id: "",
        course_type: -1,
        status: -1,
        class_time: [],
        sort_type: "desc",
        sort_field: "",
      };
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.student_key_word) {
        option.key_word = this.searchInfo.student_key_word;
      }
      if (this.searchInfo.course_adviser) {
        option.follow_staff_id = this.searchInfo.course_adviser;
      }
      if (this.searchInfo.staff_teacher_id) {
        option.edu_teacher_id = this.searchInfo.staff_teacher_id;
      }
      if (this.searchInfo.teacher_id) {
        option.teacher_id = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.subject_id) {
        option.subject_id = this.searchInfo.subject_id;
      }
      if (this.searchInfo.course_id) {
        option.course_id = this.searchInfo.course_id;
      }
      if (this.searchInfo.course_type > -1) {
        option.course_type = this.searchInfo.course_type;
      }
      if (this.searchInfo.status > -1) {
        option.status = this.searchInfo.status;
      }
      if (
        this.searchInfo.class_time &&
        this.searchInfo.class_time.length === 2
      ) {
        option.completion_start_time = dateFormat(
          "YYYY-mm-dd",
          this.searchInfo.class_time[0]
        );
        option.completion_end_time = dateFormat(
          "YYYY-mm-dd",
          this.searchInfo.class_time[1]
        );
      }
      if (this.searchInfo.sort_type) {
        option.sort_type = this.searchInfo.sort_type;
      }
      if (this.searchInfo.sort_field) {
        option.sort_field = this.searchInfo.sort_field;
      }
      completionListApi(option).then((res) => {
        if (res.error_code === 0) {
          res.data.list.map((it) => {
            if (it.completion_time !== 0) {
              it.completion_time = dateFormat(
                "YYYY-mm-dd HH:MM",
                it.completion_time * 1000
              );
            } else {
              it.completion_time = "-";
            }
          });
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    goStudentDetail(v) {
      this.mixinSavePageInfo("closingRecordSearch");
      this.$router.push({
        name: "studyDetails",
        query: {
          id: v.student.student_id,
        },
      });
    },
    clickSort(e) {
      this.searchInfo.sort_field = "create_time";
      if (e.order == "descending") {
        this.searchInfo.sort_type = "desc";
      } else if (e.order == "ascending") {
        this.searchInfo.sort_type = "asc";
      } else {
        this.searchInfo.sort_type = "";
      }
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handleSearch() {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handlePagerChange(e) {
      this.page = e;
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handleCompletionCancel(row) {
      this.$confirm(
        `确定要撤销${row.student.name}的结课记录，[${row.course.title}] 撤销结课后将恢复剩余课时，确定要撤销结课？`,
        `撤销结课 - ${row.student.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          cancelCourseFinishApi({
            completion_id: row.completion_id,
          }).then(() => {
            this.$message({
              type: "success",
              message: "撤销成功",
            });
            this.getList({
              page: this.page,
              page_size: this.pageSize,
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
/deep/ .mwow-button-filled {
  margin-left: 5px;
  padding: 0 5px !important;
  line-height: 20px !important;
  height: 20px !important;
}
/deep/.el-form {
  .el-form-item {
    margin-right: 58px;
    .el-form-item__label {
      width: 65px;
      text-align: right;
    }
    .el-form-item__content {
      display: flex;
      .el-select,
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
.searchBox {
  position: relative;
  .time-line-switch {
    position: absolute;
    top: 0;
    right: -8px;
    .btn {
      padding: 8px;
      font-size: 12px;
      cursor: pointer;
      color: #5c5d5e;
      margin-bottom: 15px;
      span {
        font-size: 14px;
        color: #c0c4cc;
        margin-left: 4px;
      }
    }
  }
}
</style>
